import api from './api';

const getDetail = (id) => api.get(`/api/v2/proctors/${id}/detail`);

export { getDetail };
